import axios from '@/plugins/axios';

export default {
  getStatuses(params = {}) {
    return axios.get('/v1/user-statuses', params);
  },
};
